import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";
import { AppConstants } from "../constants/constants";
import { ImportMessageTranslations } from "../constants/ImportConstants";

@Pipe({
  name: "importTranslate",
})
export class ImportTranslatePipe implements PipeTransform {
  siteLanguageCode: string;
  constructor(@Inject(LOCALE_ID) protected localeId: string) {
    this.siteLanguageCode = this.localeId;
  }

  transform(message: string): string {
    let result = AppConstants.BLANK;
    if(message && message.length) {
      result = ImportMessageTranslations[message.trim()] ?? message;
    }
    return this.siteLanguageCode === AppConstants.WELSH_LANG_CODE ? result : message;
  }
}
